// Engelse teksten van de tijdkiezer in de webapp (zie timePicker.nl.ts).
export const appTimePickerEn = {
    open: '{label}: choose a time',
    hourStep: 'Choose the hour',
    minuteStep: 'Choose the minutes',
    hours: 'Hours',
    minutes: 'Minutes',
    showNight: 'Night 00–05',
    back: 'Other hour',
    close: 'Close',
    type: 'Type it',
    invalid: "That isn't a time. Type 15:30 or 930, for example.",
    beforeStart: 'Choose a time after {start}.',
    /** Van schoof zo laat dat Tot niet meer op dezelfde dag paste. */
    endClamped: 'End time shortened to 23:59.',
    durations: 'How long does it take?',
    orPickEnd: 'Or choose an end time',
    durationUntil: '{duration}, until {time}',
    minutesShort: '{count} min',
    hoursShort: { one: '{count} hr', other: '{count} hrs' },
};
//# sourceMappingURL=timePicker.en.js.map